<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ประวัติการอนุมัติ</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">แสดงเฉพาะเรื่องที่คุณเป็นผู้ขอหรือมีส่วนร่วมในการอนุมัติ</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div
        class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px]">
        <span class="material-icons text-slate-400 text-xl">calendar_today</span>
        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ dateFrom() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" [ngModel]="dateFrom()" (ngModelChange)="dateFrom.set($event); onFilterChange()"
            [max]="dateTo()" (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
        <span class="text-slate-300 dark:text-slate-600">-</span>
        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ dateTo() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" [ngModel]="dateTo()" (ngModelChange)="dateTo.set($event); onFilterChange()"
            [min]="dateFrom()" (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
      </div>
      <button (click)="onRefresh()"
        class="p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">history</span>
        ประวัติของฉัน
      </h3>
      <div class="w-full sm:w-56">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สถานะ</label>
        <select [ngModel]="filterStatus()" (ngModelChange)="filterStatus.set($event); onFilterChange()"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 h-[46px]">
          <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">เลขที่</th>
            <th class="p-4">หัวข้อ</th>
            <th class="p-4">บทบาท</th>
            <th class="p-4">เมนู / ประเภท</th>
            <th class="p-4">วันที่ส่ง</th>
            <th class="p-4">วันที่เสร็จ</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4 text-center w-[100px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
            <td class="p-4 font-semibold text-slate-700 dark:text-slate-200">{{ item.name }}</td>
            <td class="p-4 text-sm">{{ item.title || '-' }}</td>
            <td class="p-4">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="item.requestUserId === userId
                  ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
                  : 'bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400'">
                {{ roleLabel(item) }}
              </span>
            </td>
            <td class="p-4">
              <div class="text-sm font-medium text-slate-700 dark:text-slate-200">{{ item.menuName || '-' }}</div>
              <div class="text-xs text-slate-400 mt-0.5">{{ recordModelLabel(item.recordModel) }}</div>
            </td>
            <td class="p-4 text-slate-400 text-xs whitespace-nowrap">{{ item.submittedDate ? (item.submittedDate | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
            <td class="p-4 text-slate-400 text-xs whitespace-nowrap">{{ item.completedDate ? (item.completedDate | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="{
                  'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': item.status === 'pending' || item.status === 'awaiting_forward',
                  'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': item.status === 'approved',
                  'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400': item.status === 'rejected',
                  'bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-300': item.status === 'cancelled'
                }">
                {{ statusLabel(item.status) }}
              </span>
            </td>
            <td class="p-4 text-center">
              <button (click)="openDetail(item)"
                class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all mx-auto"
                title="ดูรายละเอียด">
                <span class="material-icons text-base">visibility</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="items().length === 0 && !isLoading()">
            <td colspan="8" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block">search_off</span>
              <p class="font-bold">ไม่พบประวัติในช่วงวันที่ที่เลือก</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="text-sm text-slate-500 font-medium">
        แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50 dark:hover:bg-amber-900/20'">
          {{ page }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-approval-request *ngIf="isModalOpen()" [requestId]="selectedRequestId()"
  (close)="closeModal()"></app-modal-approval-request>
